import styled from 'styled-components'

const Spacer = styled.div(
  ({ height, theme }) => `
    height: ${theme.spacing[height] || '1em'}
`
)

export default Spacer
